import clsxLib, { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export default function clsx(...args: ClassValue[]): string {
  return twMerge(clsxLib(...args))
}
